import React, { Component } from 'react';

class NoMatch extends Component {
  render() {
    return (
      <div className="content">
          <h1>Are you lost?</h1>
      </div>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js